import React from "react";
import { Row, Col, List } from "antd";

import StateIcon from "../stateIcon";

const { Item } = List;

const ResultList = ({
  results,
  pageSize,
  titleMethod,
  descriptionMethod,
  stateMessageMethod,
}) => (
  <List
    dataSource={results}
    itemLayout="horizontal"
    pagination={{ pageSize: pageSize || 5 }}
    renderItem={(item) => (
      <Item>
        <Row>
          <Col span={item.message ? 12 : 24}>
            <Item.Meta
              avatar={
                <StateIcon
                  valid={item.success}
                  messages={[stateMessageMethod(item)]}
                />
              }
              title={titleMethod(item)}
              description={descriptionMethod(item)}
            />
          </Col>
          <Col span={item.message ? 12 : 0}>
            {item.message && (
              <ul>
                {item.message.split(";").map((m, i) => (
                  <li key={i}>{m}</li>
                ))}
              </ul>
            )}
          </Col>
        </Row>
      </Item>
    )}
  />
);

export default ResultList;
